module.exports = __webpack_public_path__ + "media/images/pages/solutions/services/open_ends-2ad01ef2de13f2f43d90a1ae24a39c4f.svg";